import {Application, Controller} from "@hotwired/stimulus";
import zenginCode from '@/modules/zenginCode/index';

class ZenginController extends Controller {
  static targets = ['branchCode', 'branchName'];
  static gmoAozoraBank = zenginCode['0310'];

  connect() {
    const branchCode = this.branchCodeTarget.innerText
    const branchName = ZenginController.gmoAozoraBank?.branches[branchCode]?.name
    this.branchNameTarget.innerText = branchName || '不明'
  }
}

// Registered in admin.js
export { ZenginController };
